export default function Projects() {
  const projects = [
    {
      title: "Food Ordering App",
      desc: "Full stack app using Node.js, Express, PostgreSQL, and React. Used for employee lunch management.",
      tag: "Internal Ops",
      link: "#",
      github: "#",
    },
    {
      title: "Automated Job Agent - Smart Job Aggregator & Email Notifier",
      desc: "Automated job search system that scrapes LinkedIn, Naukri, and Indeed daily, filters by my skills and experience, and sends relevant job alerts via email. Built with Node.js, Puppeteer and automated via GitHub Actions.",
      tag: "Automation",
      link: "by using GitHub Actions.",
      github: "https://github.com/shivafobl/job-agentnormal",
    },
    {
      title: "AI-Powered Interview Prep Automation",
      desc: "An automated daily learning system that delivers personalized JavaScript interview preparation directly to your inbox. Built with Node.js and GitHub Actions, this project scrapes educational content, generates AI-powered summaries using Google Gemini, and tracks progress with streak counters—all running completely free in the cloud.",
      tag: "AI Workflow",
      link: "#",
      github: "#",
    },
    {
      title: "Swap Portal",
      desc: "Full-stack employee work from home request shift-swap app built with React, Node.js/Express, and PostgreSQL, featuring secure auth, password recovery, one-swap-per-day validation, auto-approval, and swap analytics dashboards.",
      tag: "Workforce Tools",
      link: "#",
      github: "#",
    },
    {
      title: "AI Analyst",
      desc: "Full-stack risk analytics platform built with React and Node.js/Express that turns uploaded spreadsheet data into AI-powered insights and dashboards for high-risk jobs, cascading risks, and system health trends.",
      tag: "Analytics",
      link: "#",
      github: "#",
    },
    {
      title: "Portfolio Website",
      desc: "Built with React and Tailwind CSS to showcase my career progress.",
      tag: "Personal Brand",
      link: "https://portfolio-sivasaikumar.vercel.app/", // Replace with your real link later
      github: "#",
    },
  ];

  return (
    <section
      id="projects"
      className="section-frame"
    >
      <div className="section-card rounded-[2rem] px-6 py-14 sm:px-10 lg:px-14">
        <div className="flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between">
          <div>
            <div className="section-label">Projects</div>
            <h2 className="section-title mt-6 max-w-3xl text-slate-50">These are some of the projects I built while learning, experimenting, and solving real problems.</h2>
          </div>
          <p className="section-copy max-w-md">
            Most of my projects are focused on practical use cases like employee workflows, analytics dashboards, automation, and tools that reduce manual effort.
          </p>
        </div>

        <div className="mt-12 grid gap-6 grid-cols-1 md:grid-cols-2 xl:grid-cols-3">
          {projects.map((proj, index) => (
            <div
              key={index}
              className="project-card section-card rounded-[1.75rem] p-6"
              data-aos="fade-up"
              data-aos-delay={index * 45}
            >
              <div className="flex items-center justify-between gap-4">
                <span className="mono rounded-full border border-sky-400/20 bg-sky-400/10 px-3 py-1 text-[11px] uppercase tracking-[0.28em] text-sky-300">
                  {proj.tag}
                </span>
                <span className="mono text-xs text-slate-500">0{index + 1}</span>
              </div>
              <h3 className="mt-6 text-2xl font-bold leading-tight text-slate-50">{proj.title}</h3>
              <p className="mt-4 text-sm leading-7 text-slate-400">{proj.desc}</p>
              <div className="mt-8 flex gap-3">
                <a
                  href={proj.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="button-secondary text-sm"
                >
                  Live Demo
                </a>
                <a
                  href={proj.github}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="button-secondary text-sm"
                >
                  GitHub
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
